import { Roles, UserObject } from '@client/graphql/__generated__/types';
import { useCallback, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppContext } from '~/services/main/contexts/AppContext';
import { AgentSignupFlow } from '../../AgentSignUpFlow/AgentSignupFlow';
import { StytchLoginForm } from './StytchLoginForm';

interface LoginFormProps {
  onLogin: (user: UserObject) => void | Promise<void>;
}

export const LoginForm = ({ onLogin }: LoginFormProps) => {
  const navigate = useNavigate();
  const { refetchUser, user: currentUser } = useAppContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const invitationCode = searchParams.get('invitationCode');
  const [user, setUser] = useState<UserObject | null>(currentUser || null);

  const onStytchLogin = useCallback(
    async (user: UserObject) => {
      await refetchUser();

      setUser(user);

      if (user && user.roles.length === 0) {
        if (!invitationCode) {
          navigate('/auth/signup', { replace: true });
        } else {
          setSearchParams((prev) => {
            prev.set('userType', Roles.AGENT);

            return prev;
          });
        }
      }

      if (user.roles.length > 0) {
        return await onLogin(user);
      }
    },
    [refetchUser, invitationCode, navigate, setSearchParams, onLogin]
  );

  if (invitationCode && user && user.roles.length === 0) {
    return (
      <AgentSignupFlow
        stytchUser={user}
        onSignup={() => window.location.reload()}
      />
    );
  }

  return <StytchLoginForm onLogin={onStytchLogin} />;
};
